import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetokonkancabservice() {



  const cardData =
  {
    keyword: ' Pune to Konkan Cab Service',
    heading: 'Sai Trupti Cabs: Pune to Konkan Cab Service',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Konkan cab services, designed to make your coastal getaway smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space for your scenic journey. Every trip is managed by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way to the Konkan region. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to Konkan convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Konkan with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Ganpatipule Beach & Temple",
    "description": "Ganpatipule Beach is a serene stretch of golden sand on the Konkan coast, the setting for the ancient Swayambhu Ganpati Temple perched right by the sea. Palm-fringed shores meet turquoise waters, and the temple’s hill backdrop adds spiritual depth to the beachside calm. Visitors wander barefoot between waves and stone steps, savour fresh seafood in local shacks, and watch the sun set into the Arabian Sea. The air carries whispers of devotion, salt spray and mango orchards nearby. Ganpatipule beautifully embodies the peaceful rhythm of Konkan — where nature, faith and coastline merge effortlessly."
  },
  {
    "title": "Tarkarli Beach & Malvan Fort",
    "description": "Tarkarli Beach in south Konkan is a jewel of translucent waters, white sand and coral snorkelling opportunities, while nearby lies the historic Malvan sea-fort that guards the coast. The bay curves gently, house-boats float lazily, and parasailing or scuba dives reveal the underwater world. Overhead, old bastions and cannons hint at maritime rebellions and colonial history. The pace here is slow: a beach hammock, a cool drink, the sound of waves. Tarkarli blends adventure, heritage and island-style ease into one unforgettable escape."
  },
  {
    "title": "Alibaug & Kolaba Fort",
    "description": "Alibaug is the gateway to Konkan’s coastal charm — reachable from Mumbai yet far enough from the urban bustle to feel like a true seaside haven. Sandy beaches like Kashid and Alibaug, coconut groves and beach-shacks line your walk. In the low tide the majestic sea-fort of Kolaba appears, stone walls rising from surf and memory. Water-sports, ferry rides, beachfront dining and sunset horizons make Alibaug a versatile outstation from city life. Whether for a weekend drive or a lazy week by the sea, Alibaug marks the relaxing side of Konkan’s coastline."
  },
  {
    "title": "Ratnagiri & Alphonso Mango Orchards",
    "description": "Ratnagiri lies in the heart of Konkan and is famous not just for beaches but for its ripening Alphonso mango orchards and historic ports. The coastline here curves gracefully, the waves crash on rugged outcrops and the hills roll into more green than you expect. Forts, lighthouses and old trading posts remind of the region’s sea-faring past. The mango-laden verandas, the scent of ripe fruit and the quiet village roads create a sense of place that’s relaxed but layered. Ratnagiri is where you taste Konkan’s terroir, heritage and seaside rhythm."
  },
  {
    "title": "Karde, Harnai & Hidden Beaches",
    "description": "Away from the tourist crowds, beaches like Karde and Harnai in Konkan offer raw coastal beauty — quiet sands, fishing boats, mangrove inlets and lush greenery. Here you find solitude, local life, curries by the sea and views of small forts perched beside palms. The drive through narrow ghats, the smell of wet earth after rain, and the sound of waves against basalt rocks all form part of the experience. These hidden beaches show a side of Konkan that’s unpolished and deeply authentic — perfect for a slower getaway."
  },
  {
    "title": "Sindhudurg Fort & Malvani Coast",
    "description": "Off the coast of south Konkan stands the mighty Sindhudurg Fort, an island‐fortress built by the Maratha navy to command the sea and protect the shoreline. Accessed by boat from the Malvan coast, its ramparts, ancient cannons and sea-facing bastions echo history. The surrounding Malvani villages serve seafood, the beaches are quiet and the tropical forest hills rise behind. The combination of fort-exploration, sea breeze and coastal cuisine makes this region one of Konkan’s most cinematic destinations."
  },
  {
    "title": "Backwaters & Spice Plantations of Konkan",
    "description": "Beyond the surf and sand, Konkan’s interior reveals spice plantations, tranquil back-water canals and rivers that wind through coconut groves and greenery. Visitors wander through estates of pepper, cardamom and vanilla, taste Goan-Konkani lunches under tree canopies and cruise gentle waterways. The contrast between dense greenery of the Western Ghats rising behind and the open sea ahead gives Konkan a special duality: forest and coast in harmony. This lesser-explored facet of the region adds calm, culture and depth to any trip."
  },
  {
    "title": "Driving the Coastal Ghats & Konkan Highway",
    "description": "One of the joys of Konkan is the journey: the winding road along the steep Western Ghats, tunnels, sea glimpses, swaying palms and monsoon mist. The National Highway and the newer Konkan Railway carve through rugged terrain, making the drive itself a highlight. At unplanned stops you’ll encounter waterfalls pouring off cliffs, roadside tea stalls and views of endless sea. Whether you set off from Mumbai, Pune or Goa, the route through Konkan rewards you with landscape, freedom and discovery more than just the destination."
  },
  {
    "title": "Monsoon Magic & Misty Hills",
    "description": "When the monsoon sweeps across Konkan, the hills turn vividly green, waterfalls burst into life and the sea glows under heavy clouds — transforming the coastline into a dreamscape. The air fills with scent of wet earth and salt wind, the roads curve through mist and valleys whisper with rain runoff. Locals call this season “the true face of the place”. Whether you're sitting on a veranda watching waves or trekking a forest path, the monsoon in Konkan is an experience you’ll remember long after the rain has passed."
  },
  {
    "title": "Konkan Culture, Cuisine & Coastal Village Life",
    "description": "Konkan’s cultural rhythm flows through its villages, temples, fishing boats and cuisine of coconut, rice, fresh fish and mango. Festivals like---Shimga, Ganesh Chaturthi and others play out with local zest among palms and sea breeze. Traditional Konkani-Marathi homes, boat-building yards, mango harvests and thatch huts reveal a lifestyle tied to coast and hill, salt and spice. For travellers open to pausing, listening and tasting, Konkan offers more than beaches — it presents a slow-world of cultural richness, coastal calm and generous hearts."
  }
],



   "services": [
    {
      "name": "Pune to Konkan Cab Service",
      "description": "Book your Pune to Konkan Cab Service for a comfortable and scenic journey through Maharashtra’s coastal beauty. Choose from AC, Non-AC, Sedan, Ertiga, or Innova options for your travel. Our service ensures on-time pickups, professional drivers, clean vehicles, and flexible booking options. Whether you’re heading to beaches like Ganpatipule, Tarkarli, or Alibaug, we offer 24/7 support, easy online booking, and transparent fares for a smooth, enjoyable experience."
    },
    {
      "name": "Pune to Konkan Taxi Service",
      "description": "Get a reliable Pune to Konkan Taxi Service for all your travel needs. Our fleet includes AC/Non-AC taxis, Sedans, SUVs, and luxury cars for solo, family, or group travel. Enjoy scenic drives, comfortable seating, and courteous drivers. Ideal for business trips, weekend getaways, or holiday tours, we provide flexible pickup/drop points, affordable pricing, and an easy online booking process for complete travel convenience."
    },
    {
      "name": "Pune to Konkan Car Hire",
      "description": "Hire a car from Pune to Konkan for a relaxed and flexible journey. We offer a variety of vehicles like Sedans, Innovas, and Ertigas with AC and Non-AC options. Whether you’re traveling to Ratnagiri, Sindhudurg, or Dapoli, our professional drivers ensure safety and punctuality. Enjoy clean cars, GPS tracking, flexible stops, and affordable rental plans designed for comfort and convenience."
    },
    {
      "name": "AC Cab Pune to Konkan",
      "description": "Travel in comfort with our AC Cab Pune to Konkan service. Our air-conditioned cabs provide a cool, peaceful journey through the scenic coastal routes. Choose from Sedans, Innovas, and Ertigas for solo or group travel. Each trip includes professional drivers, flexible schedules, luggage assistance, and transparent fares, ensuring a relaxed and enjoyable travel experience from Pune to any Konkan destination."
    },
    {
      "name": "Non AC Cab Pune to Konkan",
      "description": "Book a Non-AC Cab from Pune to Konkan for an economical travel solution. Perfect for budget-conscious travelers, our Non-AC vehicles are clean, comfortable, and driven by experienced drivers. Enjoy safe, on-time travel with transparent pricing and easy online booking options for both one-way and round-trip journeys across the Konkan region."
    },
    {
      "name": "Innova Cab Pune to Konkan",
      "description": "Rent an Innova Cab from Pune to Konkan for spacious, family-friendly travel. The Innova offers comfortable seating, AC comfort, and ample luggage space, ideal for long-distance journeys. Whether it’s a family trip, corporate tour, or group travel, our well-maintained Innovas and experienced drivers ensure a smooth, secure, and memorable coastal ride."
    },
    {
      "name": "Ertiga Cab Pune to Konkan",
      "description": "Book an Ertiga Cab from Pune to Konkan for affordable and comfortable group travel. The 7-seater Ertiga provides enough space for families or small groups with AC/Non-AC options. Enjoy professional chauffeurs, clean interiors, luggage support, and flexible pickup/drop points. Ideal for vacations, pilgrimages, or business tours in the beautiful Konkan belt."
    },
    {
      "name": "Luxury Cab Pune to Konkan",
      "description": "Travel in style with our Luxury Cab Service from Pune to Konkan. Choose from high-end vehicles like Innova Crysta, BMW, or Mercedes with premium interiors, AC comfort, and professional chauffeurs. Ideal for weddings, corporate trips, or leisure tours, our luxury cab service ensures elegance, punctuality, and top-notch comfort on every mile of your journey."
    },
    {
      "name": "Affordable Cab Pune to Konkan",
      "description": "Get the most Affordable Cab Service from Pune to Konkan without compromising comfort. We offer transparent pricing, professional drivers, and a range of clean AC/Non-AC vehicles. Perfect for solo, family, or business travel, our service includes flexible routes, easy online booking, and round-the-clock customer support for a stress-free travel experience."
    },
    {
      "name": "Pune to Konkan Outstation Cab",
      "description": "Our Pune to Konkan Outstation Cab service provides seamless long-distance travel options. Choose from multiple vehicle types with AC/Non-AC variants for round trips or extended stays. Perfect for weekend getaways, vacations, or family visits, we ensure professional drivers, transparent billing, and flexible itineraries for a safe and enjoyable journey."
    },
    {
      "name": "Pune to Konkan One Way Cab",
      "description": "Book a Pune to Konkan One Way Cab and pay only for the distance you travel. Ideal for one-time drops or relocation trips, our one-way service provides comfortable rides, flexible timings, and professional drivers. Whether it’s Ratnagiri, Alibaug, or Sindhudurg, enjoy affordable, safe, and convenient travel at your own schedule."
    },
    {
      "name": "Pune to Konkan Drop Cab",
      "description": "Hire a Pune to Konkan Drop Cab for one-way travel with on-time pickup and door-to-door service. Our experienced drivers, clean vehicles, and transparent fares ensure a smooth journey to your desired Konkan destination. Perfect for tourists, corporate employees, or family travelers seeking reliable drop services."
    },
    {
      "name": "Corporate Cab Pune to Konkan",
      "description": "Corporate travelers can rely on our Pune to Konkan Cab Service for comfortable and professional rides. We offer executive AC/Non-AC cars, luxury sedans, and Innovas with trained chauffeurs. Enjoy timely pickups, transparent invoicing, and business-class service ideal for meetings, conferences, and official tours."
    },
    {
      "name": "Wedding Cab Pune to Konkan",
      "description": "Make your special day even more memorable with our Wedding Cab Service from Pune to Konkan. Choose from luxury sedans, Innovas, or decorated cars for bridal and guest transport. Enjoy on-time service, professional drivers, AC comfort, and flexible bookings for seamless wedding transportation across Maharashtra."
    },
    {
      "name": "Online Cab Booking Pune to Konkan",
      "description": "Book your Pune to Konkan Cab Online in just a few clicks! Enjoy instant confirmation, multiple payment options, and a wide range of vehicles to choose from. Whether for a family trip, business travel, or weekend getaway, our online platform provides affordable rates, real-time support, and transparent pricing for a hassle-free booking experience."
    }
  ],
  "tableData": [
    ["Pune to Konkan Cab Service", "Pune to Konkan Taxi Service"],
    ["Pune to Konkan Car Hire", "AC Cab Pune to Konkan"],
    ["Non AC Cab Pune to Konkan", "Innova Cab Pune to Konkan"],
    ["Ertiga Cab Pune to Konkan", "Luxury Cab Pune to Konkan"],
    ["Affordable Cab Pune to Konkan", "Pune to Konkan Outstation Cab"],
    ["Pune to Konkan One Way Cab", "Pune to Konkan Drop Cab"],
    ["Corporate Cab Pune to Konkan", "Wedding Cab Pune to Konkan"],
    ["Online Cab Booking Pune to Konkan", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Konkan Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs  provides reliable and comfortable cab services from Pune to Konkan — perfect for leisure trips, weekend getaways, and family travel."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get clear one-way fare estimates for Pune to Konkan cab rides, ensuring affordable and stress-free travel."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from sedans, SUVs, Ertiga, Innova Crysta, or luxury cars to suit your group size, luggage, and comfort preferences for the Pune to Konkan journey."
  },
  {
    "WhyChooseheading": "Experienced & Punctual Drivers",
    "WhyChoosedescription": "Our professional drivers are familiar with Pune–Konkan routes, providing a safe, smooth, and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer convenient pickups anywhere in Pune and drops at any location in Konkan — beaches, hotels, or towns."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All vehicles are regularly serviced, sanitized, and maintained to ensure comfort and reliability for long-distance travel."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel planning, and any queries for your Pune to Konkan trip."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Konkan cab easily via call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]
































  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune to Konkan cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Pune to Konkan cab services for one-way, round trips, and group travel.',
  },
  {
    question: 'How can I book a Pune to Konkan cab with Sai Trupti Cabs?',
    answer: 'You can book your Pune to Konkan cab easily through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available from Pune to Konkan?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, Tempo Travellers, and luxury cabs to suit your travel needs, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for Pune to Konkan trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in long-distance travel, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I hire a cab from Pune to Konkan for family or group trips?',
    answer: 'Certainly. Our cab services cater to family trips, group tours, and leisure travel from Pune to Konkan.',
  },
  {
    question: 'Is the Pune to Konkan cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services for Pune to Konkan trips for your convenience and flexible travel plans.',
  },
  {
    question: 'What are the Pune to Konkan cab fares?',
    answer: 'Our cab fares start from ₹3,500 for sedans, ₹4,500–₹6,000 for SUVs and Innova Crysta, depending on vehicle type, group size, and travel requirements.',
  },
  {
    question: 'What payment options are accepted for Pune to Konkan cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for hassle-free transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune to Konkan cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety measures to ensure a secure journey.',
  },
  {
    question: 'Is customer support available during the Pune to Konkan cab ride?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Pune to Konkan cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Deshpande',
    feedback: 'I booked a Pune to Konkan cab with Sai Trupti Cabs. The journey was comfortable, and the driver was very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Patil',
    feedback: 'Sai Trupti Cabs provided excellent service for our Pune to Konkan trip. Smooth ride and very courteous driver.',
    rating: 5,
  },
];















































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];
















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Konkan Cab Service",
  "image": "https://saitrupticabs.com/assets/images/pune-to-konkan-cab-service.jpg",
  "description": "Hire cabs from Pune to Konkan with Sai Trupti Cabs. Choose AC, Non-AC, Innova, Ertiga, luxury rides for one-way trips, drop services, corporate travel, weddings, or outstation trips. Affordable and reliable service available 24x7.",
  "provider": {
    "@type": "Organization",
    "name": "Sai Trupti Cabs",
    "url": "https://saitrupticabs.com"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1400"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2000",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-konkan-cab-service"
  }
};



  return (
    <div>
      <Helmet>
  <title>Pune to Konkan Cab Service | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Hire cabs from Pune to Konkan with Sai Trupti Cabs. Choose AC, Non-AC, Innova, Ertiga, luxury rides for one-way trips, drop services, corporate travel, weddings, or outstation trips. Affordable and reliable service available 24x7." 
  />
  <meta 
    name="keywords" 
    content="Pune to Konkan Cab Service, Pune to Konkan Taxi Service, Pune to Konkan Car Hire, AC Cab Pune to Konkan, Non AC Cab Pune to Konkan, Innova Cab Pune to Konkan, Ertiga Cab Pune to Konkan, Luxury Cab Pune to Konkan, Affordable Cab Pune to Konkan, Pune to Konkan Outstation Cab, Pune to Konkan One Way Cab, Pune to Konkan Drop Cab, Corporate Cab Pune to Konkan, Wedding Cab Pune to Konkan, Online Cab Booking Pune to Konkan" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/newimages/4.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetokonkancabservice;